import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Lottie from 'lottie-web';
import { AnonymousSessionService } from '../../../../core/services/anonymous-session.service';
import { SessionService } from '../../../../core/services/session.service';
import { Brand } from '../../../../shared/models/brand';
import { SilUnsubscribeType } from '../../../../shared/models/ProspectModel';
import { HelperService } from '../../../../shared/services/helper.service';
import { ContextService } from '../../services/context.service';
import { AgTranslateService } from '@ag/vc.ag-core/translate';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['../blocked/blocked.component.scss']
})
export class UnsubscribeComponent implements OnInit, AfterViewInit {
    jsonImage: string; //= './assets/good-bye-user.json';
    introText: string; //= 'Context.Unsubscribe.IntroText';
    title: string; //= 'Context.Unsubscribe.Title';
    description: string; //= 'Context.Unsubscribe.Description';
    showCtaLink: boolean;

    constructor(
        private readonly session: SessionService,
        private readonly route: ActivatedRoute,
        private readonly helperService: HelperService,
        private readonly agTranslateService: AgTranslateService,
        private readonly anonymousSessionService: AnonymousSessionService,
        private readonly contextService : ContextService,
        @Inject(DOCUMENT) private readonly document: Document
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            const culture = params.culture as string;
            const personId = params.personId as string;
            const optOutType = params.optoutType as SilUnsubscribeType;

            this.anonymousSessionService.setAnonymousSessionLanguage(culture);

            if (personId && optOutType && optOutType == SilUnsubscribeType.SilProspectConsent) {
                // TODO call service
                this.contextService.putUserPreferences(personId, optOutType).subscribe({
                    next: res => {
                        if(res.Status && res.IsUserFound){
                            this.initializeUI(true);
                        }
                    },
                    error: _error =>{
                        this.initializeUI(false);
                    }
                });
            }
            else {
                this.initializeUI(false);
            }
        });
    }
    
    loadAnimatedImage(): void{
        const svgContainer = document.getElementById('jsonImageIcon');
        Lottie.loadAnimation(
            this.helperService.getLottieConfig(
                svgContainer,
                false,
                true,
                'no-product',
                this.jsonImage
            )
        );
    }

    ngAfterViewInit(): void {
        // TODO correct?
        setTimeout(() => {
            this.session.setContext(Brand.Uppie, 'assets/images/logo-aginsurance.svg', '', '', false);
          });
    }

    nextAction(event: string): void {
        if (event === 'forward') {
            this.document.location.href = AgAppConfigService.get<string>('publicsiteurl') + this.agTranslateService.currentLang;
        }
    }
    private initializeUI(status: boolean){
        this.jsonImage = status? './assets/good-bye-user.json' :'./assets/email-envelope-error.json';
        this.introText = status? 'Context.Unsubscribe.IntroText' :'Context.Unsubscribe.IntroTextTechnicalError';
        this.title = status? 'Context.Unsubscribe.Title' :'Context.Unsubscribe.TitleTechnicalError';
        this.description = status? 'Context.Unsubscribe.Description' :'Context.Unsubscribe.DescriptionTechnicalError';
        this.showCtaLink = status;
        this.loadAnimatedImage();
    }
}